import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Backdrop } from '../../common-components/Backdrop/Backdrop';
import { AssemblerOrderDetails } from '../AssemblerOrderDetails/AssemblerOrderDetails';

interface IModalAssemblerOrderDetailsProps {
  visible: boolean;
  close: (orderId?: number) => void;
  title: string;
  orderId?: number;
}

const ModalAssemblerOrderDetails: React.FC<IModalAssemblerOrderDetailsProps> = ({
  visible,
  close,
  title,
  orderId
}) => {

  const [modalVisible, setModalVisible] = React.useState<boolean>(false);

  const backdrop = React.useMemo(() => modalVisible ? <Backdrop /> : null, [modalVisible]);

  if (!visible) return null;

  return (
    <Modal
      show={visible}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
      dialogClassName='modal-large'
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='modalAssemblerOrderDetailsBody' style={{ height: '80vh', maxHeight: '80vh', overflowY: 'auto' }}>
        <AssemblerOrderDetails orderId={orderId} />
      </Modal.Body>

      {backdrop}
    </Modal>
  );

  function clickCloseModal() {
    close(orderId);
  }
}

export { ModalAssemblerOrderDetails };